import React, { useEffect, useState } from 'react';
import { createDept, getDepts } from '../../api/deptApi';

function DeptForm({ comCode, comName, onCancel, onCreated }) {
  const [form, setForm] = useState({
    dept_code: '',
    dept_name: '',
    parent_dept_code: '',
    parent_dept_name: '',
    manager_userid: '',
    sort_order: 0,
  });
  const [deptList, setDeptList] = useState([]);

  useEffect(() => {
    if (!comCode) return;
    getDepts(comCode).then(res => setDeptList(res.data));
  }, [comCode]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleParentChange = (e) => {
    const selectedCode = e.target.value;
    const selectedDept = deptList.find(d => d.dept_code === selectedCode);
    setForm({
      ...form,
      parent_dept_code: selectedCode,
      parent_dept_name: selectedDept?.dept_name || '',
    });
  };

  const handleSubmit = async () => {
    await createDept(form, comCode);
    alert('등록 완료');
    if (onCreated) onCreated(); // ✅ 부모에게 알림
  };

  return (
    <div>
      <h3>{comName ? `${comName} | ` : ''}➕ 부서 등록</h3>

      <input
        className="form-control mb-2"
        name="dept_code"
        value={form.dept_code}
        onChange={handleChange}
        placeholder="부서 코드"
      />

      <input
        className="form-control mb-2"
        name="dept_name"
        value={form.dept_name}
        onChange={handleChange}
        placeholder="부서명"
      />

      <select
        className="form-select mb-2"
        value={form.parent_dept_code}
        onChange={handleParentChange}
      >
        <option value="">상위 부서 선택</option>
        {deptList.map(dept => (
          <option key={dept.dept_code} value={dept.dept_code}>
            {dept.dept_name} ({dept.dept_code})
          </option>
        ))}
      </select>
      <input
        type="number"
        className="form-control mb-2"
        name="sort_order"
        value={form.sort_order}
        onChange={handleChange}
        placeholder="정렬 순서 (숫자)"
      />
      <input
        className="form-control mb-2"
        name="manager_userid"
        value={form.manager_userid}
        onChange={handleChange}
        placeholder="담당자 ID"
      />

      <button className="btn btn-success" onClick={handleSubmit}>저장</button>
      <button className="btn btn-secondary ms-2" onClick={onCancel}>취소</button>
    </div>
  );
}

export default DeptForm;